module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-product"
  }, [_c('div', {
    staticClass: "space-20"
  }), _vm._v(" "), (!_vm.loaded.skus || !_vm.loaded.product) ? _c('loading') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded.skus && _vm.loaded.product),
      expression: "loaded.skus && loaded.product"
    }],
    staticClass: "container"
  }, [(_vm.product) ? _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Catálogo")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-double-right"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.getRouteParams()
    }
  }, [_vm._v(_vm._s(_vm.product.subcategory.name))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-double-right"
  }), _vm._v(" " + _vm._s(_vm.product.name) + "\n    ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('ul', {
    staticClass: "list-group characteristics"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.product.characteristics), function(char) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [_vm._v(_vm._s(char.name))]), _vm._v(" "), _c('div', {
      staticClass: "list-group-item-text"
    }, _vm._l((char.values), function(qnt, value) {
      return _c('div', {
        staticClass: "checkbox"
      }, [_c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(qnt))]), _vm._v(" "), _c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.filters),
          expression: "filters"
        }],
        attrs: {
          "name": "filters",
          "type": "checkbox"
        },
        domProps: {
          "value": char.id + '-' + value,
          "checked": Array.isArray(_vm.filters) ? _vm._i(_vm.filters, char.id + '-' + value) > -1 : (_vm.filters)
        },
        on: {
          "change": [function($event) {
            var $$a = _vm.filters,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = char.id + '-' + value,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.filters = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.filters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.filters = $$c
            }
          }, function($event) {
            return _vm.applyFilter(char.id, value)
          }]
        }
      }), _vm._v(" " + _vm._s(value) + " " + _vm._s(char.unit) + "\n                ")])])
    }), 0)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('list-skus', {
    attrs: {
      "parent": "product",
      "parent-id": _vm.productId,
      "filters": _vm.filters
    },
    on: {
      "loaded": _vm.loadedEvent
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-group-item"
  }, [_c('label', {
    staticClass: "no-margin"
  }, [_vm._v("FILTROS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-573c16ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageProduct.vue
// module id = 301
// module chunks = 5